import { render, staticRenderFns } from "./departamentos.vue?vue&type=template&id=ee1992d2"
import script from "./departamentos.vue?vue&type=script&lang=js"
export * from "./departamentos.vue?vue&type=script&lang=js"
import style0 from "./departamentos.vue?vue&type=style&index=0&id=ee1992d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports